export * from './nav-dropdown.directive';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/nav-dropdown/index.ts